<template>
    <div :class="['page', { 'page--embed': partnerAppEmbedCustomization }]">
        <div class="image">
            <img :src="require('../assets/404.webp')">
            <div class="image__text">{{ $t('unavailable.pageNotFound') }}</div>
        </div>
        <div class="buttons">
            <a class="button"
                @click="goToPreviousPage"
            >
                {{ $t('global.button.previous') }}
            </a>
            <router-link to="/"
                class="button button--green"
            >
                {{ $t('global.button.homePage') }}
            </router-link>
        </div>
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';
export default {
    name: 'page-not-found',
    computed: {
        ...mapGetters(['partnerAppEmbedCustomization']),
    },
    methods: {
        goToPreviousPage() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.image {
    max-width: 45rem;
    min-height: 35rem;
    font-size: 2rem;
    line-height: 3.1rem;
    background: url("../assets/socios-logo-transparent.webp") no-repeat center;
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    text-align: center;

    @include max-width(sm) {
        max-width: 30rem;
        min-height: 35rem;
    }

    @include min-width(lg) {
        min-width: 74rem;
        min-height: 53rem;
    }

    @include min-width(lg) {
        min-width: 50rem;
        min-height: 53rem;
    }

    img {
        padding-bottom: 8rem;
        width: 100%;
    }
}

.buttons {
    padding: 9rem 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @include max-width(sm) {
        flex-direction: column;
    }
}

.button {
    display: block;
    margin: 0 2rem;
    font-size: 1.8rem;
    line-height: 4.1rem;
    width: 20rem;
    border-radius: 0.5rem;
    border: 0.1rem solid $white-color;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;

    @include max-width(sm) {
        margin-bottom: 2rem;
    }

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }

    &--green {
        background: $lima-color;
        color: $daintree-color;
        border: none;
    }
}

.page {
    background: $cyprus-color;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 13.5rem);

    @include min-width(md) {
        min-height: 100vh;
    }

    &--embed {
        min-height: 100vh;
    }
}
</style>